import gql from 'graphql-tag'

export const GET_ORDER = gql`
  query GetOrder($uuid: ID!) {
    getOrder(uuid: $uuid) {
      id
      uuid
      eventId
      status
    }
  }
`

export const CREATE_ORGANIZATION_STORE_ORDER = gql`
  mutation CreateOrganizationStoreOrder($order: OrganizationStoreOrderInput!) {
    createOrganizationStoreOrder(order: $order)
  }
`
export const POPULATE_ORGANIZATION_STORE_ORDER = gql`
  mutation PopulateOrganizationStoreOrder(
    $orderUUID: String!
    $buyer: OrganizationStoreBuyerInfo!
  ) {
    populateOrganizationStoreOrder(orderUUID: $orderUUID, buyer: $buyer) {
      id
      status
      createdAt
      updatedAt
      price
      userId
      uuid
    }
  }
`

export const POPULATE_SPORT_ORGANIZATION_STORE_ORDER = gql`
  mutation PopulateSportOrganizationStoreOrder($orderUUID: String!, $buyer: JSON!) {
    populateSportOrganizationStoreOrder(orderUUID: $orderUUID, buyer: $buyer)
  }
`

export const CREATE_THEATER_SUBSCRIPTION_ORDER = gql`
  mutation CreateTheaterSubscriptionOrder($order: TheaterSubscriptionOrderInput!) {
    createTheaterSubscriptionOrder(order: $order) {
      id
      status
      createdAt
      updatedAt
      price
      uuid
      buyer
    }
  }
`

export const POPULATE_THEATER_SUBSCRIPTION_ORDER = gql`
  mutation PopulateTheaterSubscriptionOrder(
    $orderUUID: String!
    $buyer: TheaterSubscriptionBuyerInfo!
  ) {
    populateTheaterSubscriptionOrder(orderUUID: $orderUUID, buyer: $buyer) {
      id
      status
      createdAt
      updatedAt
      price
      buyer
    }
  }
`

export const UPDATE_ORDER = gql`
  mutation UpdateOrder($uuid: ID!, $input: OrderInput!) {
    updateOrder(uuid: $uuid, input: $input) {
      id
      eventId
      uuid
      status
      createdAt
      updatedAt
      promoCodeId
      buyer
      price
      signature
      approvalCode
      language
    }
  }
`

export const POPULATE_ORDER = gql`
  mutation populateOrderData(
    $orderId: ID!
    $eventId: ID!
    $buyer: AttendeeInputPublic!
    $attendees: [AttendeeInputPublic!]!
    $legalEntity: InstitutionData
    $lang: String
    $ticketInsurance: Boolean
  ) {
    populateOrderData(
      orderId: $orderId
      eventId: $eventId
      buyer: $buyer
      attendees: $attendees
      legalEntity: $legalEntity
      lang: $lang
      ticketInsurance: $ticketInsurance
    ) {
      id
    }
  }
`
export const POPULATE_ORDER_DATA_CONFERENCE_TICKETING = gql`
  mutation populateOrderDataConferenceTicketing(
    $orderId: ID!
    $eventId: ID!
    $buyer: AttendeeInputPublic!
    $attendees: [AttendeeInputPublic!]!
    $ticketInsurance: Boolean
  ) {
    populateOrderDataConferenceTicketing(
      orderId: $orderId
      eventId: $eventId
      buyer: $buyer
      attendees: $attendees
      ticketInsurance: $ticketInsurance
    ) {
      id
    }
  }
`

export const CANCEL_ORDER_CONFERENCE_TICKETING = gql`
  mutation cancelOrderConferenceTicketing($orderUUID: String!) {
    cancelOrderConferenceTicketing(orderUUID: $orderUUID)
  }
`

export const DELETE_ORDER = gql`
  mutation DeleteOrder($orderId: ID!) {
    deleteOrder(orderId: $orderId)
  }
`
export const GET_ORDER_INFO_BY_UUID = gql`
  query GetOrderInfoByUUID($uuid: ID!) {
    getOrderInfoByUUID(uuid: $uuid) {
      user {
        firstName
        type
        ticketSellerOrganization {
          id
          name
          isCustomFiscalisation
          oib
          fees {
            useEventFeePerTicket
          }
          address
        }
      }
      id
      fiscalisationInfo
      eventId
      promoCodeId
      invoiceNumber
      buyer
      paymentType
      kiData
      giftCardAmount
      createdAt
      status
      canResumeReservationCheckout
      price
      uuid
      event {
        id
        slug
        title
        from
        fixedFeePerTicket
        variableFeePercentage
        VATPercentage
        to
        cover
        metadata
        organizerMessage
        extraModules {
          ticketPersonalization
        }
        organization {
          type
          OIB
          address
          city
          fixedFeePerTicket
          variableFeePercentage
          postalCode
          id
          publicName
          legalName
          logo
          VATPercentage
          VATObligor
          description
          facebookLink
          webLink
          preferredLanguage
        }
        location {
          id
          address1
          address2
          city
          postalCode
          state
          country
          venue
          latitude
          longitude
        }
      }
      theaterSubscriptionPurchases {
        theaterSubscription {
          id name price valid_from valid_to coverUrl
          organization { id slug }
          venue { id name seats predefinedSections }
        }
      }
      purchases {
        id
        createdAt
        orderId
        attendeeId
        orderItemId
        subscriptionId
        bundleOfferId
        promoCodeId
        promoCode {
          code
        }
        orderItem {
          id
          name
          price
          type
          sectionSeats
          currency
          organizationId
          itemMeta
          hasDateValidationRange
          validityType
          entryFrom
          entryTo
        }
        accreditation {
          id
          barcode
          qrcode
          status
          avatar
          zones
          categoryId
          ticketLocation
          fields
        }
      }
    }
  }
`
export const GET_ORGANIZATION_STORE_ORDER_INFO_BY_UUID = gql`
  query GetOrganizationStoreOrderInfoByUUID($uuid: ID!) {
    getOrganizationStoreOrderInfoByUUID(uuid: $uuid) {
      user {
        firstName
        lastName
        email
      }
      id
      fiscalisationInfo
      promoCodeId
      buyer
      paymentType
      price
      uuid
      purchases {
        id
        createdAt
        orderId
        attendeeId
        bundleOfferId
        orderItemId
        orderItem {
          id
          name
          price
          type
          sectionSeats
          currency
          organizationId
        }
      }
    }
  }
`
export const REFETCH_SELECTED_SEATS_BY_ORDER_UUID = gql`
  query RefetchSelectedSeatsByOrderUUID($uuid: ID!) {
    fetchSelectedSeatsByOrderUUID(uuid: $uuid) {
      user {
        firstName
        type
      }
      id
      fiscalisationInfo
      eventId
      promoCodeId
      buyer
      price
      uuid
      event {
        id
        title
        from
        to
        venueAvailability {
          availability
          eventId
        }
        location {
          id
          address1
          address2
          city
          postalCode
          state
          country
          venue
          latitude
          longitude
        }
      }
      purchases {
        id
        createdAt
        orderId
        attendeeId
        bundleOfferId
        orderItemId
        orderItem {
          id
          name
          price
          sectionSeats
          type
          currency
          color
          itemMeta
        }
        accreditation {
          id
          barcode
          qrcode
          status
          avatar
          zones
          categoryId
          fields
          ticketLocation
        }
      }
    }
  }
`

export const FINISH_ORDER = gql`
  mutation FinishOrder($orderId: ID!, $input: OrderInput!) {
    finishOrder(orderId: $orderId, input: $input) {
      id
      uuid
      eventId
      status
      createdAt
      updatedAt
      promoCodeId
      buyer
      price
      signature
      approvalCode
      language
    }
  }
`

export const GET_USER_ORDERS = gql`
  query GetUserOrders {
    getUserOrders
  }
`

export const GET_TICKET_SELLERS_ORDERS = gql`
  query getTicketSellersOrders(
    $sortField: String = "id"
    $ascending: Boolean = true
    $selectedPage: Int = 1
    $pageSize: Float
  ) {
    getTicketSellersOrders(
      sortField: $sortField
      ascending: $ascending
      selectedPage: $selectedPage
      pageSize: $pageSize
    )
  }
`
export const GET_TICKET_SELLERS_REPORT = gql`
  query getTicketSellersReport($from: DateTime!, $to: DateTime!) {
    getTicketSellersReport(from: $from, to: $to) {
      id
      name
      buyer {
        paymentType
      }
      paymentType
      status
      orderId
      eventId
      orderCreated
      orderRefunded
      eventTitle
      organizationId
      organizationName
      isTisakTicketSeller
      tisakFeePerTicketWithVat
      tisakFeeTotalWithVat
      tisakFeeSellerShareWithoutVat
      tisakFeeSellerShareWithVat
      tisakFeeCoreEventShareWithVat
      tisakFeeUsesDynamicModel
      fiscalisationInfo {
        useEventFeePerTicket
        fiscalisationError
        full_receipt {
          items {
            name
            amt
            single_item_price
            price
          }
        }
      }
      price
      count
      totalPrice
    }
  }
`
export const GET_TICKET_SELLERS_ADMIN_REPORT = gql`
  query getTicketSellersAdminReport($from: DateTime!, $to: DateTime!) {
    getTicketSellersAdminReport(from: $from, to: $to) {
      id
      name
      eventTitle
      status
      orderRefunded
      orderCreated
      price
      count
      totalPrice
      orderId
      email
      fiscalisationInfo {
        useEventFeePerTicket
        fiscalisationError
        full_receipt {
          items {
            name
            price
            single_item_price
            amt
          }
        }
      }
      firstName
      lastName
      organizationName
      organizationId
      isTisakTicketSeller
      tisakFeePerTicketWithVat
      tisakFeeTotalWithVat
      tisakFeeSellerShareWithoutVat
      tisakFeeSellerShareWithVat
      tisakFeeCoreEventShareWithVat
      tisakFeeUsesDynamicModel
      organizationFees {
        ticketPercentageFee
        ticketAdditionalFeeAmount
        coreEventAdditionalFeePercentage
        kickbackPerTicket
      }
    }
  }
`
export const GET_TICKET_SELLERS_ORDER = gql`
  query getTicketSellersOrder($orderId: ID!) {
    getTicketSellersOrder(orderId: $orderId) {
      id
      promoCodeId
      price
      uuid
      status
      refundedAt
      buyer
      fiscalisationInfo
      createdAt
      directRefundAvailable
      user {
        type
        ticketSellerOrganization {
          fees {
            useEventFeePerTicket
          }
        }
      }
      event {
        id
        title
        from
        to
        fixedFeePerTicket
        variableFeePercentage
        VATPercentage
        slug
        organization {
          fixedFeePerTicket
          variableFeePercentage
          VATPercentage
        }
        location {
          venue
        }
        orderItems {
          id
          quantity
        }
      }
      purchases {
        id
        orderItem {
          id
          name
          price
          type
          currency
        }
      }
    }
  }
`

export const REQUEST_REFUND_TICKET_SELLER = gql`
  mutation requestRefundTicketSeller($orderId: ID!) {
    requestRefundTicketSeller(orderId: $orderId) {
      success
      fiscalReversalFailed
      message
    }
  }
`

export const PURCHASE_ORDER_TICKET_SELLER = gql`
  mutation purchaseOrderTicketSeller(
    $orderItemIds: [ID!]!
    $eventId: ID!
    $price: Float!
    $paymentType: String!
    $buyerEmail: String
    $ticketOwners: JSON
    $ticketAdditionalNote: String
    $selectedSeats: [String!]
  ) {
    purchaseOrderTicketSeller(
      orderItemIds: $orderItemIds
      eventId: $eventId
      price: $price
      paymentType: $paymentType
      buyerEmail: $buyerEmail
      ticketOwners: $ticketOwners
      ticketAdditionalNote: $ticketAdditionalNote
      selectedSeats: $selectedSeats
    ) {
      id
      uuid
      eventId
      status
      createdAt
      updatedAt
      promoCodeId
      buyer
      price
      signature
      approvalCode
      language
    }
  }
`
export const GET_ORDER_FOR_INVOICE_BY_UUID = gql`
  query getOrderForInvoiceByUUID($uuid: ID!) {
    getOrderForInvoiceByUUID(uuid: $uuid)
  }
`

export const VALIDATE_THEATER_SUBSCRIPTION = gql`
  mutation ValidateTheaterSubscription($subscriptionId: Int!, $email: String!, $phone: String) {
    validateTheaterSubscription(subscriptionId: $subscriptionId, email: $email, phone: $phone) {
      hasSubscription
      existingPurchase {
        id
        email
        phone
        userId
        active
        createdAt
      }
    }
  }
`

export const CREATE_RESERVE_ORDER_FOR_THEATER_SUBSCRIPTION_PUBLIC = gql`
  mutation CreateReserveOrderForTheaterSubscriptionPublic(
    $subscriptionPlanId: Int!
    $requestUUID: String
    $subscribers: [TheaterReservationSubscribersInput!]!
  ) {
    createReserveOrderForTheaterSubscriptionPublic(
      subscriptionPlanId: $subscriptionPlanId
      requestUUID: $requestUUID
      subscribers: $subscribers
    ) {
      id
      uuid
      price
      status
      canResumeReservationCheckout
      purchases {
        id
        attendeeId
      }
    }
  }
`

export const CHECK_ORDER_WS_PAY_STATUS = gql`
  query CheckOrderWsPayStatus($order: WsPayOrderCheckInput!, $isTheaterSubscriptionOrder: Boolean) {
    checkOrderWsPayStatus(order: $order, isTheaterSubscriptionOrder: $isTheaterSubscriptionOrder) {
      success
      paymentStatus
    }
  }
`
